import { render, staticRenderFns } from "./GeneralCompanyInfo.vue?vue&type=template&id=0c51d264&scoped=true&lang=pug&"
import script from "./GeneralCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCompanyInfo.vue?vue&type=style&index=0&id=0c51d264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c51d264",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VForm,VImg,VProgressCircular,VRow,VSpacer,VTextField})
